const pathToImage = require('../../images/map/marker.png').default;

const defaultClusterStyle = {
  textColor: '#fff',
  backgroundColor: '#e44b14',
  borderColor: '#fff',
  borderWidth: 3
};

export const clusterMarkerIcons = () => [
  {
    ...defaultClusterStyle,
    height: 30,
    width: 30
  },
  {
    ...defaultClusterStyle,
    height: 36,
    width: 36
  },
  {
    ...defaultClusterStyle,
    height: 44,
    width: 44
  },
  {
    ...defaultClusterStyle,
    height: 51,
    width: 51
  }, 
  {
    ...defaultClusterStyle,
    height: 61,
    width: 61
  }
];

export const markerOptions = () => {
  return {
    icon: {
      url: pathToImage
    }
  }
};